import { useRouter, type ErrorComponentProps } from "@tanstack/react-router";
import { useQueryErrorResetBoundary } from "@tanstack/react-query";

export function ProductRouteError({ reset }: ErrorComponentProps) {
  const router = useRouter();
  const queryError = useQueryErrorResetBoundary();
  return (
    <main id="main" data-shell-page tabIndex={-1} role="alert">
      <h1>This page could not be loaded.</h1>
      <button
        onClick={() => {
          queryError.reset();
          reset();
          void router.invalidate();
        }}
      >
        Try again
      </button>
    </main>
  );
}
